import { gql } from '@common/hooks';
import { InvoiceInstallmentFragmentType } from '@pay-bill/graphql/fragments';
import {
  FullValidationErrorFragment,
  FullValidationErrorFragmentType,
} from '@common/graphql/fragments';

export type ArchiveInvoiceInstallmentArgs = {
  invoiceInstallmentId: string;
};

export type ArchiveInvoiceInstallmentResponse = {
  archiveInvoiceInstallment: {
    success: boolean;
  };
};

export const ArchiveInvoiceInstallmentMutation = gql`
  mutation ArchiveInvoiceInstallment($invoiceInstallmentId: ID!) {
    archiveInvoiceInstallment(invoiceInstallmentId: $invoiceInstallmentId) {
      success
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export type UpdateInvoiceInstallmentArgs = {
  invoiceInstallmentId: string;
  input: {
    paymentAmountCents: number;
    paidAt: moment.Moment;
  };
};

export type UpdateInvoiceInstallmentResponse = {
  updateInvoiceInstallment: {
    invoiceInstallment: InvoiceInstallmentFragmentType | null;
    errors: FullValidationErrorFragmentType[] | null;
  };
};

export const UpdateInvoiceInstallmentMutation = gql`
  mutation UpdateInvoiceInstallment(
    $invoiceInstallmentId: ID!
    $input: UpdateInvoiceInstallmentInput!
  ) {
    updateInvoiceInstallment(
      invoiceInstallmentId: $invoiceInstallmentId
      input: $input
    ) {
      invoiceInstallment {
        id
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export type CreateInvoiceInstallmentArgs = {
  worksInvoiceId: string;
  input: {
    paymentAmountCents: number;
    paidAt: moment.Moment;
  };
};

export type CreateInvoiceInstallmentResponse = {
  createInvoiceInstallment: {
    invoiceInstallment: InvoiceInstallmentFragmentType | null;
    errors: FullValidationErrorFragmentType[] | null;
  };
};

export const CreateInvoiceInstallmentMutation = gql`
  mutation CreateInvoiceInstallment(
    $worksInvoiceId: ID!
    $input: CreateInvoiceInstallmentInput!
  ) {
    createInvoiceInstallment(worksInvoiceId: $worksInvoiceId, input: $input) {
      invoiceInstallment {
        id
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
